import { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { FORM_CATEGORY } from 'settings/constants/transaction';
import { tasksStatusesIds } from 'settings/constants/transactionTasks';
import { routes } from 'settings/navigation/routes';

import {
  getTransactionEffect,
  setTransactionTaskParamsEffect,
  setTransactionTasksLastStateEffect,
} from 'store/effects';
import { getPublishedFormEffect } from 'store/effects/formProcess';
import { getTransactionAccessByTaskSelector } from 'store/selectors/transaction';
import { getTransactionTaskAccess } from 'store/selectors/transactionTasks';
import { getUserId } from 'store/selectors/user';

import { tableColumns } from 'pages/Workshop/Transactions/TransactionTasks/components/Tasks/components/TasksList/tableColumns';
import { handleViewForm } from 'utils';

export const useManageTasksLists = ({
  showSelection,
  handleSelectTask,
  selectedTasks,
  showSelectAll,
  tableClassName,
  isAggregatedTasks = true,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { hasFullAccess } = useSelector(getTransactionAccessByTaskSelector);
  const { hasAccess } = useSelector(getTransactionTaskAccess);
  const userId = useSelector(getUserId);

  const [transactionDrawerProps, setTransactionDrawerProps] = useState({
    transactionId: '',
    isProject: false,
  });

  const [openTransactionDrawer, setOpenTransactionDrawer] = useState(false);
  const [formProcessDetail, setFormProcessDetail] = useState();

  const handleNewFormTask = (EntityId, transactionId, taskId) => {
    dispatch(
      getPublishedFormEffect({ formId: EntityId }, (err, form) => {
        if (!err) {
          const { data } = form;
          history.push({
            pathname: routes.workshopFormProcessRequest,
            state: {
              formId: data?.value?.FormId,
              versionId: data?.value?.Id,
              propertyTransactionId: transactionId,
              taskId: taskId,
            },
          });
        }
      }),
    );
  };

  const handleFormTask = (formProcessDetails) => {
    if (formProcessDetails) {
      const { url, shouldOpenDetails, formProcessId, type } = formProcessDetails;
      if (shouldOpenDetails && formProcessId) {
        setFormProcessDetail(formProcessId);
      } else if (url) {
        handleViewForm(history, url, type);
      }
    }
  };

  const onClickTask = useCallback(
    (record) => {
      if (record) {
        const {
          TransactionId: transactionId,
          Id: taskId,
          CampaignId: campaignId,
          Category,
          EntityId,
          Status,
          formProcessDetails,
        } = record;

        const category = Category?.Name;

        if (category === FORM_CATEGORY && Status === tasksStatusesIds.new && transactionId) {
          handleNewFormTask(EntityId, transactionId, taskId);
        } else if (category === FORM_CATEGORY) {
          handleFormTask(formProcessDetails);
        } else {
          isAggregatedTasks &&
            transactionId &&
            dispatch(getTransactionEffect({ id: transactionId }));
          dispatch(
            setTransactionTaskParamsEffect({
              taskId,
              transactionId,
              campaignId,
              isTaskDetail: true,
            }),
          );
          dispatch(setTransactionTasksLastStateEffect({ taskId }));
        }
      }
    },
    [dispatch, history],
  );

  const handleTransactionDrawer = (transactionId, isProject) => {
    setTransactionDrawerProps({ transactionId, isProject });
    setOpenTransactionDrawer(true);
  };

  const handleSelectAllTask = (taskIds, checked) => {
    handleSelectTask(taskIds, checked);
  };

  const tableProps = (dataSource?) => {
    return {
      columns: tableColumns({
        isAggregatedTasks,
        showSelection,
        handleSelectTask,
        userId,
        hasAccess,
        hasFullAccess,
        openTransactionDrawer: handleTransactionDrawer,
        handleSelectAllTask,
        selectedTasks,
        showSelectAll,
        ...(showSelectAll && {
          tableDataSource: dataSource || [],
        }),
      }),
      onRow: (record) => {
        return {
          onClick: () => {
            onClickTask(record);
          },
        };
      },
      tableClassName,
      isDraggableTable: !isAggregatedTasks,
    };
  };

  return {
    tableProps,
    openTransactionDrawer,
    setOpenTransactionDrawer,
    transactionDrawerProps,
    formProcessDetail,
    setFormProcessDetail,
  };
};
